import { useConfig } from '../../contexts/ConfigContext'
import { useLocation } from 'react-router-dom'
import ReturnHomeButton from '../shared/ReturnHomeButton'

/**
 * Header Component - Minimal Style for Dashboard Pages
 *
 * Displays app title and page-specific branding
 * Includes return home button for navigation
 * Matches minimal header pattern used across dashboard types
 */
function Header() {
  const { getAppTitle } = useConfig()
  const location = useLocation()

  // Determine the page title and icon based on the current route
  const getPageInfo = () => {
    if (location.pathname.startsWith('/datasets')) {
      return { title: 'Datasets', icon: '📁' }
    }
    // Default to Traditional Dashboard for /dashboard routes
    return { title: 'Traditional Dashboard', icon: '📊' }
  }

  const { title, icon } = getPageInfo()

  return (
    <header className="bg-white shadow-sm border-b">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <img src="/img/logo.png" alt="App Logo" className="h-8 w-8" />
              <span className="text-xl font-bold text-gray-900 hidden sm:inline">
                {getAppTitle()}
              </span>
            </div>

            <div className="hidden sm:block text-gray-300">|</div>

            <div className="flex items-center gap-2">
              <span className="text-2xl">{icon}</span>
              <h1 className="text-xl sm:text-2xl font-bold text-primary-600">
                {title}
              </h1>
            </div>
          </div>

          <ReturnHomeButton variant="button" />
        </div>
      </div>
    </header>
  )
}

export default Header
